/* Stable partition of the entire filtered collection, not just the current page.
 * Shopify handles filtering and sorting for each availability stream. */
if (!customElements.get('biri-stock-list')) customElements.define('biri-stock-list', class extends HTMLElement {
  async connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const current = new URL(location.href);
    // An explicit availability filter already defines the requested inventory group.
    const requested = [...new Set(current.searchParams.getAll('filter.v.availability'))];
    if (requested.length === 1) return;
    const total = Number(this.dataset.total), size = 12;
    if (!total) return;
    const page = Math.max(1, Math.min(Math.ceil(total / size), Number(current.searchParams.get('page')) || 1));
    const status = this.querySelector('[data-stock-status]');
    const strings = document.getElementById('BiriStockStrings')?.dataset || {};
    this.setAttribute('aria-busy', 'true');
    status.textContent = strings.loading || '';
    const cache = new Map();
    const get = (available, number) => {
      const key = available + ':' + number;
      if (!cache.has(key)) cache.set(key, (async () => {
        const url = new URL(current);
        url.searchParams.set('section_id', 'biri-stock-page');
        url.searchParams.set('filter.v.availability', String(available));
        url.searchParams.set('page', String(number));
        const response = await fetch(url, {signal: AbortSignal.timeout(15000)});
        if (!response.ok) throw Error('Stock feed unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const feed = doc.querySelector('[data-stock-feed]');
        if (!feed || Number(feed.dataset.page) !== number) throw Error('Invalid stock feed');
        const rows = [...feed.querySelectorAll('[data-stock-item]')];
        if (rows.some(row => row.dataset.available !== String(Boolean(available)))) throw Error('Availability filter unsupported');
        return {count: Number(feed.dataset.count), rows};
      })());
      return cache.get(key);
    };
    try {
      const [available, sold] = await Promise.all([get(1, 1), get(0, 1)]);
      if (available.count + sold.count !== total) throw Error('Inventory changed; retain native list');
      const start = (page - 1) * size, end = Math.min(start + size, total), rows = [];
      for (const [kind, groupStart, count] of [[1, 0, available.count], [0, available.count, sold.count]]) {
        const first = Math.max(start, groupStart) - groupStart;
        const last = Math.min(end, groupStart + count) - groupStart;
        if (last <= first) continue;
        for (let n = Math.floor(first / size) + 1; n <= Math.ceil(last / size); n++) {
          const feed = await get(kind, n);
          rows.push(...feed.rows.slice(Math.max(0, first - (n - 1) * size), Math.min(size, last - (n - 1) * size)));
        }
      }
      if (rows.length !== end - start) throw Error('Incomplete stock feed');
      const container = this.querySelector('.biri-product-rows');
      container.replaceChildren(...rows.map(row => row.firstElementChild));
      this.dispatchEvent(new CustomEvent('shopify:section:load', {bubbles: true}));
      // Native pagination has the same page size/count and retains all active filters.
      this.dataset.stockOrdered = 'true';
      status.textContent = '';
    } catch (error) {
      status.textContent = strings.error || '';
    } finally {
      this.removeAttribute('aria-busy');
    }
  }
});
